export default __webpack_public_path__ + "static/graphicOneImg-0c0c9f87e93aedfadb7a954b8f03c45b.svg";